import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwModalComponent } from './sw-modal.component';
import { SwNoticeComponent } from './sw-notice.component';
import { SwMessageService } from './sw-message.service';
import { SwIconComponent } from '../sw-icon/sw-icon.component';
import { SwTipComponent } from './sw-tip.component';

/**
 * 提示框组件
 */
@NgModule({
  imports: [CommonModule],
  declarations: [SwModalComponent, SwNoticeComponent, SwIconComponent, SwTipComponent],
  exports: [SwTipComponent, SwIconComponent],  
  providers: [SwMessageService],
  entryComponents: [SwModalComponent, SwNoticeComponent]
})



export class SwMessageModule {
  
}